import { render, staticRenderFns } from "./PurchaseAndVisit.vue?vue&type=template&id=52e95896&scoped=true&"
import script from "./PurchaseAndVisit.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndVisit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAndVisit.vue?vue&type=style&index=0&id=52e95896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e95896",
  null
  
)

export default component.exports